// Colocadores de una licitación (docs/ingresos-licitaciones.md). Funciones puras, sin
// Firestore: las usan el formulario de la licitación, el de órdenes y la pestaña.
import { AXON_CUIT, FEE_MAX_BPS } from '../constants/colocadores';
import { parseCuitDigits } from './formatters';

/** Colocadores embebidos en la licitación ([] en las licitaciones anteriores). */
export const colocadoresDeLicitacion = (licitacion) => (Array.isArray(licitacion?.colocadores)
  ? licitacion.colocadores.filter(c => c && typeof c.id === 'string' && c.id)
  : []);

export const tieneColocadores = (licitacion) => colocadoresDeLicitacion(licitacion).length > 0;

export const esAxon = (colocador) => parseCuitDigits(colocador?.cuit) === AXON_CUIT;

/** Si Axon es colocador, el fee lo paga la emisora y la licitación exige su CUIT. */
export const incluyeAxon = (colocadores) => (colocadores || []).some(esAxon);

export const nombresColocadores = (colocadores) => (colocadores || [])
  .map(c => c.nombre)
  .filter(Boolean)
  .join(' / ');

/**
 * Lo que antes se cargaba como "Colocador / Mercado": en las licitaciones con colocadores
 * va en `mercado`; en las anteriores sigue en el texto libre `colocador`.
 */
export const mercadoDeLicitacion = (licitacion) => {
  if (typeof licitacion?.mercado === 'string') return licitacion.mercado;
  return tieneColocadores(licitacion) ? '' : (licitacion?.colocador || '');
};

/**
 * Colocador por el que se colocó una orden: el que tiene cargado si es de la licitación;
 * si la orden no tiene (o no coincide) y la licitación tiene uno solo, ese. null si no se
 * puede saber. Mismo criterio que la Cloud Function que publica el fee.
 */
export const resolverColocadorOrden = (orden, colocadores) => {
  const lista = colocadores || [];
  const propio = orden?.colocadorId ? lista.find(c => c.id === orden.colocadorId) : null;
  if (propio) return propio;
  return lista.length === 1 ? lista[0] : null;
};

/**
 * Fee en bps tipeado en un formulario. '' → null (no cargado); texto que no es un número
 * de bps entre 0 y 10.000 → NaN. 0 es válido: "confirmado, sin fee".
 */
export const parseFeeBps = (texto) => {
  const limpio = String(texto ?? '').trim();
  if (!limpio) return null;
  if (!/^\d+([.,]\d+)?$/.test(limpio)) return NaN;
  const fee = parseFloat(limpio.replace(',', '.'));
  return Number.isFinite(fee) && fee <= FEE_MAX_BPS ? fee : NaN;
};

export const feeToForm = (feeBps) => (Number.isFinite(feeBps) ? String(feeBps).replace('.', ',') : '');

/** bps válido (número entre 0 y 10.000) o null. */
export const bpsONull = (value) => (
  typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= FEE_MAX_BPS ? value : null
);
